var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2528 15.592L39.1288 0.750916H33.8588L22.9668 12.4009L14.6288 0.753967H0.21582L14.8058 21.133L0.21582 36.738H5.48581L17.0908 24.325L25.9778 36.738H40.3898L25.2528 15.592ZM7.64182 4.56696H12.6668L32.9668 32.919H27.9428L7.64182 4.56696Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXN1);
export default __webpack_public_path__ + "static/media/x-n-1.2182c0dcadffa9c0f3d124efaf6a890c.svg";
export { ForwardRef as ReactComponent };